export default {"src":"/_next/static/media/flag-zh.ec25fa41.svg","height":20,"width":30,"blurWidth":0,"blurHeight":0};